import { createUseStyles } from 'react-jss'
import customColors from 'src/config/colorsV2'

export default createUseStyles({
  formInputWrapperRoot: {
    boxSizing: 'border-box',
    backgroundColor: customColors.white,
    borderRadius: '4px 4px 0px 0px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: [16, 14, 0, 0],
    flexShrink: 0,
    width: '100%',
  },
})
